import { render } from "./SaveContrat.vue?vue&type=template&id=b82063fc&scoped=true"
import script from "./SaveContrat.vue?vue&type=script&lang=js"
export * from "./SaveContrat.vue?vue&type=script&lang=js"

import "./SaveContrat.vue?vue&type=style&index=0&id=b82063fc&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Latitude E5570\\Desktop\\MES DOSSIERS\\REAL_ESTATE_DEXTER\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b82063fc"]])

export default __exports__